import { put, call, take, fork } from 'redux-saga/effects'
import { getCourseByIdSuccess } from 'src/reducers/course/action'
import { courseGetAssignmentService } from 'src/api/course'
import { GET_COURSE_BY_ID } from 'src/reducers/course/type'
import generalSaga from '../general'
import {
  operationSuccess,
  operationFail,
} from '../../reducers/operation/action'

/**
 *
 * @param {*} payload
 */
function* courseGetByIdFlow(payload) {
  try {
    const { id, callback } = payload
    const response = yield call(courseGetAssignmentService, id)

    yield put(getCourseByIdSuccess(response.data))
    yield put(operationSuccess())

    callback(response.data)
  } catch (error) {
    yield put(operationFail(error))
  }
}

/**
 *
 */
export default function* courseGetByIdWatcher() {
  while (true) {
    const action = yield take(GET_COURSE_BY_ID)
    const { payload } = action

    yield fork(generalSaga, courseGetByIdFlow, payload)
  }
}
